var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Delete") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delete-/-bin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    stroke: "#000000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "bin"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.25,21 L6.75,21 C5.92157288,21 5.25,20.3284271 5.25,19.5 L5.25,6 L18.75,6 L18.75,19.5 C18.75,20.3284271 18.0784271,21 17.25,21 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.75,
    y1: 16.5,
    x2: 9.75,
    y2: 10.5,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.25,
    y1: 16.5,
    x2: 14.25,
    y2: 10.5,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.25,
    y1: 6,
    x2: 21.75,
    y2: 6,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25,3 L9.75,3 C8.92157288,3 8.25,3.67157288 8.25,4.5 L8.25,6 L15.75,6 L15.75,4.5 C15.75,3.67157288 15.0784271,3 14.25,3 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.f479464483dc8611ac753b4e01946815.svg";
export { ForwardRef as ReactComponent };